module.exports = __webpack_public_path__ + "assets/808c406971749313ba48ebc41bc89955.mp3";